import ModuleMixin from "../ModuleMixin";
import SnapshotModule from "../../../Snapshot/SnapshotModule/SnapshotModule.vue";
import SnapshotIcon from "../../../Snapshot/SnapshotIcon/SnapshotIcon.vue";
import {
  cloneDeep,
} from "lodash-es";

// @vue/component
export default {
  name: "Antragstitel",
  components: {
    SnapshotModule,
    SnapshotIcon,
  },
  mixins: [
    ModuleMixin,
  ],
  computed: {
    optionsFormstepDetailLocal() {
      const OPTIONS = cloneDeep(this.optionsFormstepDetail);
      OPTIONS.list = [
        {
          id: "a_titel",
          htmlId: `${ this.htmlRegelNummer }_a_titel`,
          type: "text",
          label: "_LBL_GR_ANTRAGSTITEL_TITEL_",
          translate: true,
          required: true,
          view: "v",
          editonly: true,
          startupFocus: true,
        },
      ];
      return OPTIONS;
    },

    labelHeader() {
      if (this.modelParameter.frage_text) {
        return this.modelParameter.frage_text;
      }
      return "_TXT_GR_ANTRAGSTITEL_HEADER_";
    },

    statusDiff() {
      if (!this.snapshotModule) {
        return;
      }
      return this.snapshotModule.a_titel !== this.model.a_titel;
    },
  },
  methods: {
    prepareModel() {
      this.model = cloneDeep(this.module.data) || {};
    },
  },
};
